export const categoryType = [
  { id: 1, label: 'All', name: '' },
  { id: 1, label: 'Google Drive', name: 'GOOGLE_DRIVE' },
  { id: 2, label: 'Drop Box', name: 'DROP_BOX' },
  { id: 3, label: 'One Drive', name: 'ONE_DRIVE' },
  { id: 4, label: 'Facebook', name: 'FACEBOOK' },
  { id: 5, label: 'YouTube', name: 'YOUTUBE' },
  { id: 6, label: 'Reddit', name: 'REDDIT' },
  { id: 7, label: 'X Twitter', name: 'X_TWITTER' },
  { id: 8, label: 'Gmail', name: 'GMAIL' },
  { id: 9, label: 'Daum', name: 'DAUM' },
  { id: 10, label: 'Naver', name: 'NAVER' },
  { id: 11, label: 'Outlook', name: 'OUTLOOK' },
  { id: 12, label: 'Yahoo', name: 'YAHOO' },
  { id: 13, label: 'WordPress', name: 'WORDPRESS' },
  { id: 14, label: 'Brunch', name: 'BRUNCH' },
  { id: 15, label: 'Medium', name: 'MEDIUM' },
  { id: 16, label: 'MS Topic', name: 'MS_TOPIC' },
  { id: 17, label: 'Realtime Crawler', name: 'REALTIME_CRAWLER' },
  { id: 18, label: 'RSS', name: 'RSS' },
  { id: 19, label: 'Naver Blog', name: 'NAVER_BLOG' },
];

export const opts = {
  googleDrive_Cloud_option: [
    { dataSourceType: 'GG_DRIVE_CLOUD_STORAGE_ALL_DOCUMENTS' },
    { dataSourceType: 'GG_DRIVE_CLOUD_STORAGE_ALL_EXCELS' },
    { dataSourceType: 'GG_DRIVE_CLOUD_STORAGE_ALL_PRESENTATIONS' },
    { dataSourceType: 'GG_DRIVE_CLOUD_STORAGE_ALL_PDFS' },
    { dataSourceType: 'GG_DRIVE_CLOUD_STORAGE_ALL_IMAGES' },
  ],

  dropbox_Cloud_option: [
    { dataSourceType: 'DROP_BOX_CLOUD_STORAGE_ALL_DOCUMENTS' },
    { dataSourceType: 'DROP_BOX_CLOUD_STORAGE_ALL_EXCELS' },
    { dataSourceType: 'DROP_BOX_CLOUD_STORAGE_ALL_PRESENTATIONS' },
    { dataSourceType: 'DROP_BOX_CLOUD_STORAGE_ALL_PDFS' },
    { dataSourceType: 'DROP_BOX_CLOUD_STORAGE_ALL_IMAGES' },
  ],

  oneDrive_Cloud_option: [
    { dataSourceType: 'ONE_DRIVE_CLOUD_STORAGE_ALL_DOCUMENTS' },
    { dataSourceType: 'ONE_DRIVE_CLOUD_STORAGE_ALL_EXCELS' },
    { dataSourceType: 'ONE_DRIVE_CLOUD_STORAGE_ALL_PRESENTATIONS' },
    { dataSourceType: 'ONE_DRIVE_CLOUD_STORAGE_ALL_PDFS' },
    { dataSourceType: 'ONE_DRIVE_CLOUD_STORAGE_ALL_IMAGES' },
  ],

  facebook_option: [{ dataSourceType: 'FACEBOOK_ACCOUNT_ID' }, { dataSourceType: 'FACEBOOK_GROUP_ID' }],

  youtube_option: [
    { dataSourceType: 'YOUTUBE_TRENDING' },
    { dataSourceType: 'YOUTUBE_MY_SUBSCRIPTION' },
    { dataSourceType: 'YOUTUBE_MY_CHANNEL' },
    { dataSourceType: 'YOUTUBE_URL' },
    { dataSourceType: 'YOUTUBE_KEYWORD' },
  ],

  reddit_option: [
    { dataSourceType: 'REDDIT_HOME' },
    { dataSourceType: 'REDDIT_POPULAR' },
    { dataSourceType: 'REDDIT_SUBREDDIT' },
    { dataSourceType: 'REDDIT_USERNAME_CHANNEL' },
    { dataSourceType: 'REDDIT_KEYWORD' },
  ],

  twitter_option: [
    { dataSourceType: 'X_TWITTER_HOME' },
    { dataSourceType: 'X_TWITTER_MY_PROFILE' },
    { dataSourceType: 'X_TWITTER_COMMUNITIES' },
    { dataSourceType: 'X_TWITTER_ANOTHER_PROFILE' },
    { dataSourceType: 'X_TWITTER_LIST_URLS' },
    { dataSourceType: 'X_TWITTER_KEYWORD' },
  ],

  email_option: [
    { value: '7-0', dataSourceType: 'GMAIL_MAIL' },
    { value: '7-1', dataSourceType: 'DAUM_MAIL' },
    { dataSourceType: 'NAVER_MAIL' },
    { dataSourceType: 'OUTLOOK_MAIL' },
    { dataSourceType: 'YAHOO_MAIL' },
  ],

  blog_option: [
    { dataSourceType: 'NAVER_BLOG' },
    { dataSourceType: 'WORDPRESS_BLOG' },
    { dataSourceType: 'BRUNCH_BLOG' },
    { dataSourceType: 'MEDIUM_BLOG' },
  ],

  ms_topic_option: [{ dataSourceType: 'MS_TOPIC' }],

  realtime_crawler_option: [{ value: '10-0', label: 'RC_URL' }],

  rss_option: [{ value: '11-0', label: 'RSS_URL' }],
};
